interface Props {
  etiqueta: string;
  valor: number | string;
  nota?: string;
  tono?: 'normal' | 'atencion' | 'pendiente';
}

/**
 * Una cifra sola no necesita gráfica: necesita una ficha. Una barra de un solo
 * dato es ruido, no información.
 */
export function Ficha({ etiqueta, valor, nota, tono = 'normal' }: Props) {
  return (
    <article className={`ficha${tono === 'normal' ? '' : ` ficha--${tono}`}`}>
      <span className="ficha__etiqueta">{etiqueta}</span>
      <span className="ficha__valor">{valor}</span>
      {nota && <span className="ficha__nota">{nota}</span>}
    </article>
  );
}
